import Jsbridge from "@/jsbridge";
import {router, store} from "@/main";
import * as types from "@/store/constants/index_types";
import {getRoutesParams} from "@/plugins/navigation/routes";
import Vue from "vue";
import listenNative from "@/jsbridge/service/listenNative";
export const receiveOpenUrlMsg = () => {
  // 监听成功回调
  listenNative.addListen("open_url", async (url: any) => {
    console.log("receiveOpenUrlMsg open_url", url);
    handleOpenUrl(url, "active");
    return true;
  }, {
      key: "super_pay_receive"
    });
};

// 处理open_url
export const handleOpenUrl = (url: any, from: string = "static", callback?: any) => {
  try {
    Vue.prototype.$_Dialog.hide();
    const params: any = {};
    const urls = url.split("jump?");
    const query = urls && urls[1];
    if (!query) {
      if (from === "static") {
        callback();
      }
      return;
    }
    const query_arr = query.split("&");
    for (const i of query_arr) {
      const a = i.split("=");
      params[a[0]] = decodeURIComponent(a[1]);
    }
    if (from === "static") {
      router.addRoutes([
        {
          path: "/",
          redirect: {
            name: "SuperPayReceive",
            query: {
              params: JSON.stringify(params),
              t: new Date().getTime().toString()
            }
          }
        }
      ]);
    } else {
      const route = {
        name: "SuperPayReceive",
        query: {
          params: JSON.stringify(params),
          t: new Date().getTime().toString()
        }
      };
      if (router.currentRoute.name === "SuperPayReceive") {
        router.replace(route);
      } else {
        router.push(route);
      }
    }
  } catch (e) {
    console.log(e);
  }
};

// 处理支付成功之后的跳转
export const handleSucessRouter = () => {
  const currentId = store.getters[types.GETTER_CURRENT_USER_ID];
  const isShowSplash = true;
  const routes = getRoutesParams();
  if (routes.length === 1) {
    if (currentId || !isShowSplash) {
      router.push({
        name: "Home"
      });
    } else {
      router.push({
        name: "Splash"
      });
    }
  } else {
    router.go(-1);
  }
};
